<template>
  <div class="animated fadeIn">
    <b-row class>
      <b-col>
        <h2>กลุ่มของฉัน</h2>
      </b-col>
      <b-col class="pb-2">
        <b-button v-on:click="goCreateNewGroup" variant="primary" class="float-right">สร้างกลุ่มใหม่</b-button>
      </b-col>
    </b-row>
    <b-card class="mt-2">
      <b-row>
        <b-col>
          <b-table
            :items="groups"
            :fields="fields"
            striped
            responsive="sm"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:cell(groupName)="row">{{ row.item.name }}</template>
            <template v-slot:cell(members)="row">
              <div
                v-for="member in row.item.members.slice(0, 5)"
                v-bind:key="member._id"
              >{{ member.name }}</div>
              <div
                v-if="row.item.members.length > 5"
              >...และสมาชิกอีก {{ row.item.members.length - 5 }} คน</div>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
                v-on:click="openUpdateForm(row.item._id)"
                variant="warning"
                class="btn-sm mx-2"
              >แก้ไข</b-button>
              <b-button v-on:click="deleteGroup(row.item._id)" variant="danger" class="btn-sm">ลบ</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            size="md"
            :total-rows="totalGroup"
            v-model="currentPage"
            :per-page="perPage"
            first-text="หน้าแรก"
            prev-text="หน้าที่แล้ว"
            next-text="หน้าถัดไป"
            last-text="หน้าสุดท้าย"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Company from '../../services/http/Company'

export default {
  name: 'DashboardMygroupIndex',
  components: {
  },
  data () {
    return {
      groups: [],
      showAddGroup: false,
      showUpdateForm: false,
      fields: [
        { key: 'groupName', label: 'ชื่อกลุ่ม' },
        { key: 'members', label: 'สมาชิก' },
        { key: 'actions', label: 'จัดการ' }
      ],
      totalGroup: 1,
      currentPage: 1,
      perPage: 10,
      items: [
        { name: { first: 'John', last: 'Doe' }, sex: 'Male', age: 42 },
        { name: { first: 'Jane', last: 'Doe' }, sex: 'Female', age: 36 },
        { name: { first: 'Rubin', last: 'Kincade' }, sex: 'Male', age: 73 },
        { name: { first: 'Shirley', last: 'Partridge' }, sex: 'Female', age: 62 }
      ]
    }
  },
  methods: {
    goCreateNewGroup () {
      this.$router.push({ name: 'สร้างกลุ่มใหม่' })
      // this.showAddGroup = !this.showAddGroup
    },
    async init () {
      var company = new Company()
      var group = await company.getVendorGroupAll()
      if (group.code === 1) {
        this.groups = group.data
        this.totalGroup = this.groups.length
      }
    },
    groupProcressed () {
      this.makeSuccessToast()
      this.rerender()
    },
    makeSuccessToast (variant = 'success') {
      this.$bvToast.toast('ประมวลผลสำเร็จ', {
        title: 'สำเร็จ',
        variant: variant,
        solid: true
      })
    },
    rerender () {
      this.showAddGroup = false
      this.init()
    },
    async deleteGroup (id) {
      window.analytics.track('group-index-delete', {
        groupId: id
      })
      if (!confirm('ต้องการลบหรือไม่')) {
        return
      }
      var company = new Company()
      try {
        var groupDelete = await company.deleteVendorGroup(id)
      } catch (error) {
        console.log(error)
      }

      if (groupDelete.code === 1) {
        this.rerender()
      }

      window.analytics.track('group-index-deleted', {
        groupId: id
      })
    },
    toggleUpdateGroupForm (index) {
      this.groups[index].showUpdateForm = !this.groups[index].showUpdateForm
      this.$forceUpdate()
    },
    openUpdateForm (groupId) {
      window.analytics.track('group-index-update', {
        groupId: groupId
      })
      this.$router.push(
        {
          name: 'แก้ไขกลุ่ม',
          params: {
            groupId
          }
        }
      )
    }
  },
  mounted () {
    this.init()
    window.analytics.track('group-index-open')
  }
}
</script>
